/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-23 11:39:10
 *
 *******************************************************/
// @flow
//
import _ from 'lodash';
import React, { Component } from 'react';
import { Page, PageActions, Layout, Stack, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';

import OptionsTable from './options-table';
import MainMenu from 'src/components/containers/main-menu';
import DidYouKnow from 'src/components/views/merge-values/did-you-know';
import ExceededPlanNotification from 'src/components/containers/common/exceeded-plan-notifications';
import InstallationRemindStatusBanner from 'src/components/containers/common/installation-remind-status-banner';
import YoutubeModal from 'src/components/views/common/youtube-modal';
import FullItemsModal from 'src/components/views/merge-values/full-items-modal';
import { URL } from 'src/constants/links';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { MERGE_VALUES_TYPES } from 'src/constants/merge-values';

import * as FilterDataActions from 'actions/filter-data-actions';
import * as MergeValuesActions from 'actions/merge-values-actions';
import * as checklistActions from 'actions/dashboard/checklist-actions';
import TitleHelp from 'src/components/views/common/title-help';

type Props = WithI18nProps;
type State = {
  youtubeModal: boolean,
  activeFullItemsModal: boolean
};

// DONE
class MergeValues extends Component<Props, State> {
  state = {
    youtubeModal: false,
    activeFullItemsModal: false
  };

  componentDidMount() {
    const { getMergeValuesTypes, getFilterData } = this.props;
    getFilterData();
    getMergeValuesTypes();
  }

  render() {
    const { loading, types, i18n } = this.props;
    const { youtubeModal, activeFullItemsModal } = this.state;
    const noData = _.isEmpty(types);

    return (
      <div className="BC-Page BC-Page__Merge-Value">
        <MainMenu menuId="menu-filters-merge-values" />
        <Page
          title={i18n.translate('AdminHTML.MergeValues.MergeValues.pageTitle')}
          primaryAction={
            noData ? (
              ''
            ) : (
              <div className="BC-Page BC-Page__Button">
                <Stack>
                  <Button primary onClick={this.handleAddNew} disabled={loading}>
                    {i18n.translate('AdminHTML.MergeValues.MergeValues.add')}
                  </Button>
                </Stack>
              </div>
            )
          }>
          <TitleHelp
            i18n={i18n}
            onPlay={() => this.toggleModal('youtubeModal')}
            hrefUserManual={URL['Link_V2_Filter_MergeValue_ManualGuide']}
            onAnalytics={() => history.push(routes.analytics.overviewCollection())}
          />
          <Layout>
            <Layout.Section>
              <div className="BC-Container__Notifications">
                {/* Installation reminder status banner */}
                <InstallationRemindStatusBanner />

                <DidYouKnow />
                {/* Sticky notification for exceeded plan */}
                <ExceededPlanNotification />
              </div>
            </Layout.Section>
            <Layout.Section>
              <OptionsTable />
            </Layout.Section>
          </Layout>
          {!noData && (
            <PageActions
              primaryAction={{
                content: i18n.translate('AdminHTML.MergeValues.MergeValues.add'),
                onAction: this.handleAddNew,
                disabled: loading
              }}
            />
          )}
        </Page>
        <YoutubeModal
          active={youtubeModal}
          embeddedURL={URL['Link_V2_Filter_MergeValue_Video']}
          onClose={() => this.toggleModal('youtubeModal')}
          title={i18n.translate('AdminHTML.MergeValues.MergeValues.youtubeModal_Title')}
        />

        <FullItemsModal
          active={activeFullItemsModal}
          handleChange={() => this.toggleModal('activeFullItemsModal')}
          title={i18n.translate('AdminHTML.MergeValues.MergeValues.fullItemsModal_Title')}
          content={i18n.translate('AdminHTML.MergeValues.MergeValues.fullItemsModal_Content')}
        />
      </div>
    );
  }

  // Handle click save button
  handleAddNew = () => {
    const { types, options } = this.props;
    if (types.length < options.length + MERGE_VALUES_TYPES.length) {
      history.push(routes.mergeValues.new());
    } else {
      this.setState({ activeFullItemsModal: true });
    }
  };

  toggleModal = fieldName => {
    const value = this.state[fieldName];
    this.setState({ [fieldName]: !value });
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  getFilterData: () => dispatch(FilterDataActions.getFilterData(ownProps.i18n)),
  getMergeValuesTypes: () => dispatch(MergeValuesActions.getMergeValuesTypes(ownProps.i18n)),
  getChecklist: () => dispatch(checklistActions.getChecklist(ownProps.i18n))
});

const mapStateToProps = (state, props) => {
  const { mergeValues } = state;
  return {
    loading: _.get(mergeValues, 'getNamesLoading', false),
    types: _.get(mergeValues, 'types', []),
    options: _.get(state.filterData, 'filterData.optionsList', [])
  };
};
export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(MergeValues));
